const CcnStatus = {
  active: 1,
  inActive: 2
};

export default CcnStatus;
